export default {"src":"/_next/static/media/baby-girl.8117389b.svg","height":537,"width":479,"blurWidth":0,"blurHeight":0};